import React from 'react';
import styles from './NoDataComponent.module.css';
import { useTranslation } from 'react-i18next';
export default function NoDataComponent() {
  const { t } = useTranslation();
  return <div className={styles.noData}>{t('main.partnerScore.partnerScoreDataAvailability.noDataInfo')}</div>;
}
